import styled, { css } from 'styled-components';

import {
  lineHeight,
  typographyV2,
} from '~/design-tokens/typography/Typography.styles';

import type { OutsideTag, PriceChange } from './PriceDisplay';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 48px;
`;

export const PriceContainer = styled.div<{ $isPrimary: boolean }>`
  display: flex;
  align-items: baseline;
  gap: 8px;

  ${props =>
    props.$isPrimary
      ? css`
          ${Price} {
            ${typographyV2.titleLg}
          }
        `
      : css`
          ${Price} {
            ${typographyV2.titleMd}
            ${lineHeight.l400}
          }
        `}
`;

export const PriceAndCurrencyContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: baseline;
`;

export const Price = styled.span`
  font-family: var(--font-roboto-mono);
`;

export const Currency = styled.span`
  ${typographyV2.bodyXs}
  text-transform: uppercase;
  color: var(--text-soft);
`;

const priceChangeColors = {
  default: 'var(--text-soft)',
  negative: 'var(--viz-bearish)',
  positive: 'var(--viz-bullish)',
};

export const PriceChangeContainer = styled.div<{
  $status: PriceChange['status'];
}>`
  display: flex;
  gap: 8px;
  color: ${props => priceChangeColors[props.$status]};
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodyXs}
`;

export const PriceChangeLabel = styled.span`
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodySm}
`;
export const PercentageChangeLabel = styled.span`
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodySm}
`;

export const LabelsContainer = styled.p`
  display: flex;
`;

export const LiveLabel = styled.span`
  color: var(--text-success);
  ${typographyV2.bodySm}
`;

export const OutsideHoursTag = styled.span<{ $tagType: OutsideTag }>`
  ${typographyV2.bodySm}
  color: ${({ $tagType }) =>
    $tagType === 'pre' ? 'var(--text-primary)' : 'var(--text-soft)'};
  margin-right: 12px;
`;
